<template>
  <div
    v-if="
      searchPageStore.sectionResultsExceedMaxVisible(filterDefinition) ||
      showAllFilterOptions
    "
  >
    <input
      type="text"
      :name="`${filterDefinition.name}_search`"
      v-model.trim="searchText"
      :placeholder="`Filter ${filterDefinition.description}...`"
      @input="
        searchPageStore.updateSectionSearchText(
          ($event.target as HTMLInputElement).value,
          filterDefinition
        )
      "
    />
  </div>
  <SearchPageFilterOption
    v-for="filterOption in filterOptions"
    :key="filterOption.id"
    :filterOption="filterOption"
    :filterDefinition="filterDefinition"
    :showAllFilterOptions="showAllFilterOptions"
  />
  <div
    v-if="
      searchPageStore.sectionResultsExceedMaxVisible(filterDefinition) &&
      !showAllFilterOptions
    "
    class="seeall-link"
    @click="searchPageStore.openFilterModal(filterDefinition.filterCategoryId)"
  >
    See all
  </div>
</template>
<script setup lang="ts">
import { ref, PropType, watch, computed } from "vue";
import { FilterDefinition } from "@/types/search-page";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import SearchPageFilterOption from "@/components/v2/search-page/SearchPageFilterOption.vue";

const searchPageStore = useSearchPageStore();

const props = defineProps({
  filterDefinition: {
    type: Object as PropType<FilterDefinition>,
    required: true,
  },
  showAllFilterOptions: {
    type: Boolean,
    default: false,
  },
});

const searchText = ref<string>("");

const filterOptions = computed(() => {
  if (props.filterDefinition.maxVisibleOptions && !props.showAllFilterOptions) {
    return searchPageStore
      .filteredSectionResults(props.filterDefinition)
      .slice(0, props.filterDefinition.maxVisibleOptions);
  }

  if (props.showAllFilterOptions) {
    return searchPageStore.filteredSectionResults(props.filterDefinition);
  }

  return props.filterDefinition.options;
});

watch(
  () => props.filterDefinition.search,
  (newValue) => {
    searchText.value = newValue;
  }
);
</script>

<style scoped src="@/assets/css/search-page/search-page.css"></style>
